import { useAppDispatch } from "hooks";
import { routesEnum } from "pages/Routes";
import { useCallback } from "react";
import { useHistory } from "react-router";
import { appendThemeTags, setHost } from "store/ducks/filterHackathon/slice";
import { domain } from "utils/domain";

export const useSearchHostGlobal = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const handleSaveSearch = useCallback((searchTerm: string) => {
    const host = window.location.host;
    if (window.location.pathname.includes("challenges/") && host !== domain) {
      const routes =
        window.location.protocol +
        "//" +
        domain +
        routesEnum.home +
        `?host=${searchTerm}`;
      window.location.assign(routes);
      return;
    }
    dispatch(setHost(searchTerm));
    history.push(routesEnum.home);
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return handleSaveSearch;
};

export const useSearchTagGlobal = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const searchTag = useCallback((tags: string) => {
    const host = window.location.host;
    if (window.location.pathname.includes("challenges/") && host !== domain) {
      const routes =
        window.location.protocol +
        "//" +
        domain +
        routesEnum.home +
        `?tag=${tags}`;
      window.location.assign(routes);
      return;
    }
    dispatch(appendThemeTags(tags));
    history.push(routesEnum.home);
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return searchTag;
};
